import React, { useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Alert,
  Box
} from "@mui/material";
import { register } from "../services/api";
import { SubTitle } from "./common/Title";

const UserRegisterDialog = ({ open, onClose }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleRegister = async () => {
    if (password !== confirmPassword) {
      setError("As senhas não coincidem");
      return;
    }
    try {
      await register(username, password);
      setSuccess("Usuário criado com sucesso!");
      setTimeout(() => {
        onClose();
        setSuccess("");
        setUsername("");
        setPassword("");
        setConfirmPassword("");
      }, 2000);
    } catch (err) {
      setError("Erro ao registrar. Tente novamente.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <SubTitle sx={{marginTop:"20px", marginLeft:"15px"}}>Cadastrar novo usuário</SubTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <TextField
          label="Nome de usuário"
          fullWidth
          margin="dense"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Senha"
          type="password"
          fullWidth
          margin="dense"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirmar senha"
          type="password"
          fullWidth
          margin="dense"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancelar</Button>
        <Button onClick={handleRegister} color="primary">Cadastrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserRegisterDialog;
